import Vue from 'vue'

Vue.filter('priceFilter', function (value) {
	let val = (value / 1).toFixed(0).replace('.', ',')
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
});

Vue.filter('priceFilterComma', function (value) {
	let val = (value / 1).toFixed(0).replace(',', '.')
	return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
});
